import { createAction, props } from '@ngrx/store';

export const ALL = '[AccountManagerContact] All';

export const AllAction = createAction(
  ALL,
  props<{
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  }>()
);

export type All = ReturnType<typeof AllAction>;
